import React from 'react';


const Head = () => {
  return (
    <div className="top-header">
  <div className="contact-info">
    <a href="tel:+918100154008" className="call-btn">📞 +91 8100154008</a>
    <span className="email">✉️ arogyakunjhomeoclinic@gmail.com</span>
    <span className="address">
      📍 Ground Floor Shanti Tara Plaza  Sultanpur Rd, Arjunganj, Marhar Mau Kala, Lucknow, Uttar Pradesh 226002
    </span>
  </div>
  <div className="social-icons">
    <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
      <i className="fa fa-facebook-f"></i>
    </a>
    <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
      <i className="fa fa-twitter"></i>
    </a>
    <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
      <i className="fa fa-instagram"></i>
    </a>

    <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
      <i className="fa fa-youtube-play"></i>
    </a>

  </div>
</div>

  );
};

export default Head;
